import type { ComponentType } from "react";
import { AiAgentIllustration } from "./AiAgent";
import { AnalyticsIllustration } from "./Analytics";
import { AutoRepliesIllustration } from "./AutoReplies";
import { AutomationsIllustration } from "./Automations";
import { BlockedIllustration } from "./Blocked";
import { BroadcastsIllustration } from "./Broadcasts";
import { CatalogIllustration } from "./Catalog";
import { ChannelsIllustration } from "./Channels";
import { ContactsIllustration } from "./Contacts";
import { FlowsIllustration } from "./Flows";
import { FormsIllustration } from "./Forms";
import type { IllustrationProps } from "./Frame";
import { GenericIllustration } from "./Generic";
import { InboxIllustration } from "./Inbox";
import { KnowledgeIllustration } from "./Knowledge";
import { LoyaltyIllustration } from "./Loyalty";
import { NoResultsIllustration } from "./NoResults";
import { OrdersIllustration } from "./Orders";
import { PaymentsIllustration } from "./Payments";
import { PlansIllustration } from "./Plans";
import { QrIllustration } from "./Qr";
import { SequencesIllustration } from "./Sequences";
import { StoreIllustration } from "./Store";
import { SuccessIllustration } from "./Success";
import { TeamIllustration } from "./Team";
import { TemplatesIllustration } from "./Templates";

const registry = {
  inbox: InboxIllustration,
  contacts: ContactsIllustration,
  flows: FlowsIllustration,
  automations: AutomationsIllustration,
  autoReplies: AutoRepliesIllustration,
  sequences: SequencesIllustration,
  broadcasts: BroadcastsIllustration,
  templates: TemplatesIllustration,
  forms: FormsIllustration,
  store: StoreIllustration,
  catalog: CatalogIllustration,
  orders: OrdersIllustration,
  payments: PaymentsIllustration,
  aiAgent: AiAgentIllustration,
  knowledge: KnowledgeIllustration,
  analytics: AnalyticsIllustration,
  team: TeamIllustration,
  plans: PlansIllustration,
  channels: ChannelsIllustration,
  qr: QrIllustration,
  loyalty: LoyaltyIllustration,
  success: SuccessIllustration,
  blocked: BlockedIllustration,
  noResults: NoResultsIllustration,
  generic: GenericIllustration,
};

/** Every illustration key, so pages can render by name: `<Illustration name="inbox" />`. */
export type IllustrationName = keyof typeof registry;

export const illustrations: Record<IllustrationName, ComponentType<IllustrationProps>> = registry;

export const illustrationNames = Object.keys(registry) as IllustrationName[];
